import { Button, Caption, List, Placeholder, Section, Title } from '@telegram-apps/telegram-ui';
import { formatImageUrl } from '../../lib/imageUrl';
import { PRODUCT_IMAGE_BACKGROUND, PRODUCT_IMAGE_OBJECT_FIT } from '../../lib/imagePolicy';
import type { ProductMediaItem } from '../../types/product';
import { mediaCaption } from './productModalUtils';

type ProductGalleryPanelProps = {
  productId: string;
  media: ProductMediaItem[];
  busy: boolean;
  onDone: () => void;
  onOpenViewer: (item: ProductMediaItem) => void;
  onSetPrimary: (input: { productId: string; mediaId: string }) => void;
  onMoveMedia: (fromIndex: number, direction: -1 | 1) => void;
  onDeleteMedia: (item: ProductMediaItem) => void;
};

export function ProductGalleryPanel({
  productId,
  media,
  busy,
  onDone,
  onOpenViewer,
  onSetPrimary,
  onMoveMedia,
  onDeleteMedia,
}: ProductGalleryPanelProps) {
  return (
    <List style={{ maxHeight: '75vh', overflowY: 'auto' }}>
      <Section header="Галерея товара">
        {media.length === 0 ? (
          <Placeholder header="Пусто" description="У товара пока нет медиа" />
        ) : (
          <div style={{ display: 'grid', gap: 12, padding: '0 16px 12px' }}>
            {media.map((item, idx) => {
              const src = formatImageUrl(item.thumbnailUrl || item.url);
              return (
                <div
                  key={item.id}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '72px 1fr',
                    gap: 10,
                    alignItems: 'start',
                    borderBottom: '1px solid var(--tgui--separator_color)',
                    paddingBottom: 12,
                  }}
                >
                  <button
                    type="button"
                    onClick={() => onOpenViewer(item)}
                    style={{
                      width: 72,
                      height: 90,
                      padding: 0,
                      border: item.isPrimary
                        ? '2px solid var(--tg-theme-button-color, #2481cc)'
                        : '1px solid var(--tgui--separator_color)',
                      borderRadius: 8,
                      overflow: 'hidden',
                      background: PRODUCT_IMAGE_BACKGROUND,
                    }}
                  >
                    <img
                      src={src}
                      alt={item.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: PRODUCT_IMAGE_OBJECT_FIT,
                        display: 'block',
                      }}
                    />
                  </button>
                  <div style={{ minWidth: 0 }}>
                    <Title level="3" style={{ margin: 0 }}>
                      {item.title}
                    </Title>
                    <Caption>{mediaCaption(item)}</Caption>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginTop: 8 }}>
                      <Button
                        mode={item.isPrimary ? 'filled' : 'outline'}
                        size="s"
                        disabled={item.isPrimary || busy}
                        onClick={() => onSetPrimary({ productId, mediaId: item.id })}
                      >
                        Главное
                      </Button>
                      <Button mode="outline" size="s" disabled={idx === 0 || busy} onClick={() => onMoveMedia(idx, -1)}>
                        Выше
                      </Button>
                      <Button
                        mode="outline"
                        size="s"
                        disabled={idx === media.length - 1 || busy}
                        onClick={() => onMoveMedia(idx, 1)}
                      >
                        Ниже
                      </Button>
                      <Button mode="plain" size="s" disabled={item.kind === 'source' || busy} onClick={() => onDeleteMedia(item)}>
                        Убрать
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Section>
      <Section header=" ">
        <Button mode="filled" stretched onClick={onDone}>
          Готово
        </Button>
      </Section>
    </List>
  );
}
